import { BACKGROUND_COLOR_MAP } from '../../../constants/background-color.constants';
import {
  TComponentDetails,
  TContentHubSeriesDetailsParams,
  TContentHubSeriesDetailsProps,
  TSeriesDetailFeatureItemData,
  TSeriesDetailsData,
} from '../types/productSeriesDetailFeature.types';

export class SeriesDetailsModel {
  public readonly data?: TSeriesDetailsData;
  public readonly params?: TContentHubSeriesDetailsParams;
  public readonly itemData?: TSeriesDetailFeatureItemData;

  constructor(props: TContentHubSeriesDetailsProps) {
    this.data = props?.fields?.apiData || null;
    this.params = props?.params || undefined;
    this.itemData = props.fields.itemData;
  }

  get contextItemUrl(): string {
    return this.itemData?.contextItemUrl || '';
  }

  get backgroundColor(): TContentHubSeriesDetailsParams {
    return {
      backgroundColorOverlaySplit: BACKGROUND_COLOR_MAP.get(this.params?.backgroundColorOverlaySplit || ''),
      backgroundColorOverlayCardColumn: BACKGROUND_COLOR_MAP.get(this.params?.backgroundColorOverlayCardColumn || ''),
    };
  }

  get innerComponents(): TComponentDetails[] {
    return this.data?.innerComponents || [];
  }

  get eyebrow(): string | undefined {
    return this.data?.eyebrow;
  }

  get title(): string | undefined {
    return this.data?.title;
  }

  get description(): string | undefined {
    return this.data?.description;
  }
}
